import Image from 'next/image';
import { FC, useEffect } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { CardButtons } from '../CardButtons';
import Markdown from 'markdown-to-jsx';
import styles from './InstagramCard.module.css';
import { FormType } from '../../../../../../types/FormTypes';

type InstagramCardProps = {
  responseIndex: number;
  text: string;
  id: string;
};

export const InstagramCard: FC<InstagramCardProps> = ({
  text,
  responseIndex,
  id,
}) => {
  const { socialInput } = useFormContext();
  const { personaSocialInput, metaAdsInput } = useFormContext();

  // Custom H1 component that adds a '#' at the beginning
  const CustomH1: React.FC<{ children: string }> = ({ children, ...props }) => (
    <b {...props}>#{children}</b>
  );

  const CustomMarkdown: React.FC<{ children: string }> = ({ children }) => {
    return (
      <Markdown
        options={{
          overrides: {
            h1: {
              component: CustomH1,
            },
          },
        }}
      >
        {children}
      </Markdown>
    );
  };

  const monitorPlaceholderImageDimensions = () => {
    const placeholderImage = document.getElementById(
      `ig-placeholder-image-${responseIndex}`
    );

    if (placeholderImage && placeholderImage.clientWidth > 0) {
      placeholderImage.style.height = `${placeholderImage.clientWidth}px`;
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', monitorPlaceholderImageDimensions);
      return () =>
        window.removeEventListener('resize', monitorPlaceholderImageDimensions);
    }
  }, []);

  if (!socialInput) return null;

  return (
    <div className={styles['container']}>
      <div className={styles['handle-container']}>
        <div className={styles['avatar']} />
        <p>
          <b>{socialInput.companyName || personaSocialInput?.brand}</b>
        </p>
      </div>
      <div
        id={`ig-placeholder-image-${responseIndex}`}
        className={styles['placeholder-image']}
      />
      <div className={styles['text-container']}>
        <div className={styles['icons-container']}>
          <Image
            src="/icons/HeartClear.svg"
            alt="Like"
            layout="fixed"
            objectFit="contain"
            height={28}
            width={28}
          />
          <Image
            src="/icons/ChatClear.svg"
            alt="Comment"
            layout="fixed"
            objectFit="contain"
            height={26}
            width={26}
          />
          <Image
            src="/icons/SendTriangleClear.svg"
            alt="DM"
            layout="fixed"
            objectFit="contain"
            height={26}
            width={26}
          />
        </div>
        <p>
          Liked by <b>SuperCopy</b> and <b>others</b>
        </p>
        <p className={styles['response-text']}>
          <b>{socialInput.companyName || personaSocialInput?.brand}</b>{' '}
          <CustomMarkdown>{text}</CustomMarkdown>
        </p>
        <p>View all 105 comments</p>
      </div>
      <CardButtons responseIndex={responseIndex} id={id} />
    </div>
  );
};
